export default __webpack_public_path__ + "station-defect-oil-gray.png?c406ce96ad8441500bed5b0bb38f73a4";